module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ote_color.2155aa6d.svg";